export const stats = {
  main_title: "Statistics",
  overview: "Overview",
  performed_activites: "Performed activities",
  total_activities: "Scheduled activities",
  whole_year: "Full year",
  period: "Period",
  year: "Year",
  my_homes: "My homes",
  homes: "Homes",
  users: "Users",
  objectives: "Objectives",
  x_times: " times",
  staff: "Staff (check-off)",
  per_day: "/day",
  per_day_template: "{1} activities checked off in {2} days = {3} per / day",
  day: "day",
  days: "days",
  box_performed: "Performed",
  box_unable: "Unable",
  box_not_performed: "Not performed",
  performed: "Performed",
  unable: "Unable",
  not_performed: "Not performed",
  activites: "Activities",
  wellbeing: "Well-being",
  loading_stats: "Loading statistics...",
  statistics_subtitle: "HR goals and routines metrics",
  hr_only_info: "HR statistics are available only in HR mode.",
  select_organization: "Select organisation",
  select_organization_to_view: "Select an organisation to view data.",
  select_period: "Select period",
  select_employee: "Select employee",
  show_all: "Show all",
  period_all: "All time",
  period_year: "Last year",
  period_month: "Last month",
  period_week: "Last week",
  hr_goals: "Goal statistics",
  hr_routines: "Routine statistics",
  no_statistics_data: "No statistics data available.",
  error_loading_hr_statistics: "Unable to load HR statistics.",
  error_loading_organizations: "Unable to load organisations.",
  kpi_total_employees: "Total employees",
  kpi_active_this_period: "Active this period",
  kpi_avg_goal_completion_rate: "Avg goal completion",
  kpi_avg_routine_completion_rate: "Avg routine completion",
  kpi_total_coins_awarded: "Total coins awarded",
  overall_summary: "Overall Summary",
  employee_breakdown: "Employee Breakdown",
  activities: "Activities",
  count: "Count",
  employee: "Employee",
  goal_count: "Goals",
  avg_completion_rate: "Avg completion",
  total_routine_dates: "Routine dates",
  completed_routine_dates: "Completed dates",
  routine_count: "Routines",
  total_dates: "Total dates",
  completed_dates: "Completed dates",
  completion_rate: "Completion rate",
  tab_company: "Company data",
  tab_individual: "Individual",
};
